import { render, staticRenderFns } from "./shipment.vue?vue&type=template&id=6f7319b4&"
import script from "./shipment.vue?vue&type=script&lang=js&"
export * from "./shipment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports